window.loggedIn = false;

const globalState = {
    loggedIn: window.staticData.loggedin
}
export default globalState